import { Component, ComponentFactoryResolver, Input, OnInit, SimpleChanges } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
// Service
import { BroadcastService, ModalService } from '@cv-invision/core';
import { GenericFormService } from '@cv-invision/cv.invision-views.ux';
import { EditableTableComponent } from './editable-table/editable-table.component';
import { GenericCrudService } from '../service/generic-crud.service';
import { GenericTableModel } from '../model/generic-table.model';

@Component({
	selector: 'cv-generic-crud-table',
	templateUrl: './editable-table/editable-table.component.html',
	providers: [ConfirmationService, MessageService]
})
export class BaseTableComponent extends EditableTableComponent implements OnInit {
	@Input() tableConfig: GenericTableModel;
	@Input() model: any;
	@Input() params: any;
	@Input() extraData: any;
	@Input() callBacks: any;
	@Input() formBuilderConfig: any;

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: GenericCrudService,
		protected modalService: ModalService,
		protected componentFactoryResolver: ComponentFactoryResolver,
		protected broadcast: BroadcastService,
		public formService: GenericFormService
	) {
		super(
			confirmationService,
			messageService,
			service,
			modalService,
			componentFactoryResolver,
			broadcast,
			formService
		);
	}

	ngOnInit(): void {
		super.setIntegrationParamsData(this.params);
		super.setIntegrationExtraData(this.extraData);
		super.ngOnInit();
	}

	/**
	 * Detect changes on values variable in order to option selected
	 * @param changes
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['params']) {
			super.setIntegrationParamsData(changes['params'].currentValue);
		}

		if (changes['extraData']) {
			super.setIntegrationExtraData(changes['extraData'].currentValue);
		}

		super.ngOnChanges(changes);
	}

	/**
	 * Override original onRownEditInit function.
	 * Callbacks may return false to skip the default edit flow (e.g. async prep then open modal).
	 *
	 * @param row
	 */
	onRowEditInit(row: any) {
		if (this.callBacks && 'onRowEditInit' in this.callBacks) {
			// Call the onRowEditInit callback
			const result = this.callBacks.onRowEditInit(row, this.model, this.extraData, this);
			// If the result is false, skip the default edit flow
			if (result === false) {
				return;
			}
		}
		super.onRowEditInit(row);
	}
}
